import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class CompaniesRequest extends GenericRequest {

    term;
    page;
    retrieve_document_stats;
    show_only_deleted;
    show_only_active;

    constructor(page, term = '', retrieve_document_stats = false, show_only_active = null, show_only_deleted = false) {
        super(METHOD_POST, ApiEndpoints.COMPANIES);

        this.page = page;
        this.term = term;
        this.retrieve_document_stats = retrieve_document_stats;
        this.show_only_deleted = show_only_deleted;
        this.show_only_active = show_only_active;
    }

    overrideRequest() {
        const request = {};
        request.retrieve_document_stats = this.retrieve_document_stats;
        request.criteria = {};
        if ( this.page ) request.criteria.page = this.page;
        if ( this.term ) request.criteria.term = this.term;
        if ( this.show_only_active !== null && this.show_only_active !== undefined ) {
            // only_active: solo activas | only_inactive: solo inactivas | no poner nada TODAS
            if ( this.show_only_active ) {
                request.criteria.only_active = true;
            } else {
                request.criteria.only_inactive = true;
            }
        }
        request.criteria.show_only_deleted = this.show_only_deleted;
        return request;
    }

}



// WEBPACK FOOTER //
// ./src/app/company/ws/CompaniesRequest.js